import React, { useEffect, useId, useRef } from "react";
import Button from "../../ui/Button";
import DrawerA11yWrapper from "../../ui/DrawerA11yWrapper";
import TenantPolicyDetail from "./TenantPolicyDetail";

const ensurePolicyDrawerAnimations = (() => {
  let injected = false;
  return () => {
    if (injected) return;
    const styleTag = document.createElement("style");
    styleTag.setAttribute("data-policy-drawer", "true");
    styleTag.innerHTML = `
@keyframes policyDrawerSlide {
  from { transform: translateX(40px); opacity: 0; }
  to { transform: translateX(0); opacity: 1; }
}

@keyframes policyDrawerFade {
  from { opacity: 0; }
  to { opacity: 1; }
}
`;
    document.head.appendChild(styleTag);
    injected = true;
  };
})();

export default function TenantPolicyDetailDrawer({ tenantPolicyId, onClose, onPolicyUpdated }) {
  const titleId = useId();
  const closeRef = useRef(null);

  useEffect(() => {
    ensurePolicyDrawerAnimations();
  }, []);

  if (!tenantPolicyId) return null;

  return (
    <DrawerA11yWrapper
      open={Boolean(tenantPolicyId)}
      onClose={onClose}
      labelledBy={titleId}
      initialFocusRef={closeRef}
      backdropStyle={overlayStyle}
      containerStyle={drawerStyle}
    >
      <div style={layoutStyle}>
        <div style={headerStyle}>
          <div id={titleId} style={{ fontSize: "18px", fontWeight: 600 }}>
            Policy Details
          </div>
          <Button
            onClick={onClose}
            variant="ghost"
            style={closeButtonStyle}
            aria-label="Close policy drawer"
            ref={closeRef}
          >
            X
          </Button>
        </div>
        <div style={contentStyle}>
          <TenantPolicyDetail
            tenantPolicyId={tenantPolicyId}
            inline
            onRequestClose={onClose}
            onPolicyUpdated={onPolicyUpdated}
          />
        </div>
      </div>
    </DrawerA11yWrapper>
  );
}

const overlayStyle = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.4)",
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "stretch",
  zIndex: 3000,
  animation: "policyDrawerFade 0.2s ease-out",
};

const drawerStyle = {
  width: "640px",
  maxWidth: "94vw",
  height: "100%",
  background: "#ffffff",
  display: "flex",
  flexDirection: "column",
  boxShadow: "0 0 20px rgba(0,0,0,0.15)",
  animation: "policyDrawerSlide 0.25s ease-out",
};

const layoutStyle = {
  height: "100%",
  display: "flex",
  flexDirection: "column",
};

const headerStyle = {
  padding: "16px 20px",
  borderBottom: "1px solid #e5e7eb",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  background: "#fff",
  position: "sticky",
  top: 0,
  zIndex: 10,
};

const closeButtonStyle = {
  background: "transparent",
  border: "none",
  cursor: "pointer",
  fontSize: "16px",
  color: "#6b7280",
  padding: "4px 8px",
};

const contentStyle = {
  padding: "12px 16px",
  overflowY: "auto",
  flex: 1,
};
